import { useCallback, useState } from "react";

import { SortDirection } from "../components/datatable/interfaces";

export const useSort = (
  defaultSortKey = "",
  defaultSortDirection: SortDirection = SortDirection.NotSorted
) => {
  const [sortKey, setSortKey] = useState<string>(defaultSortKey);
  const [sortDirection, setSortDirection] = useState<SortDirection>(
    defaultSortKey !== "" && defaultSortDirection === SortDirection.NotSorted
      ? SortDirection.Asc
      : defaultSortDirection
  );

  const updateSort = useCallback(
    (key: string) => {
      if (sortKey === key) {
        setSortDirection((prevDirection) => {
          return prevDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
        });
      } else {
        setSortKey(key);
        setSortDirection(SortDirection.Asc);
      }
    },
    [sortKey]
  );

  const sort = useCallback(
    (data: any[]) => {
      if (!sortKey || !sortDirection) {
        return data;
      }

      return [...data].sort((a, b) => {
        const valueA = a[sortKey] ?? "";
        const valueB = b[sortKey] ?? "";

        if (!isNaN(valueA) && !isNaN(valueB)) {
          return sortDirection === SortDirection.Asc
            ? Number(valueA) - Number(valueB)
            : Number(valueB) - Number(valueA);
        }

        if (valueA < valueB) {
          return sortDirection === SortDirection.Asc ? -1 : 1;
        }

        if (valueA > valueB) {
          return sortDirection === SortDirection.Asc ? 1 : -1;
        }

        return 0;
      });
    },
    [sortDirection, sortKey]
  );

  return { sortKey, sortDirection, sort, updateSort };
};
